module.exports = __webpack_public_path__ + "img/poly-2.9841e512.png";